import { flexRender, Header, type RowData } from 'src/lib/tanstack-react-table';
import { useTranslation } from 'react-i18next';
import isString from 'lodash/isString';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import { TableCell } from '../TableCell';
import { StyledWrapper, StyledSortIcon, StyledIconButton } from './TableHeadCell.styled';

export interface TableHeadCellProps<TData extends RowData> {
  headerObj: Header<TData, unknown>;
}

export const TableHeadCell = <TData extends RowData>({ headerObj }: TableHeadCellProps<TData>) => {
  const { t } = useTranslation();

  const header = headerObj?.column?.columnDef?.header;

  // translate header if it is a string
  const value = isString(header) ? t(header) : header;

  const headerContent = headerObj.isPlaceholder ? null : flexRender(value, headerObj.getContext());

  /** Sort contexts — call methods on the column instance (v9 prototype APIs). */
  const { column } = headerObj;
  const isSorted = column.getIsSorted();
  const canSortColumn = column.getCanSort();
  const handleSort = column.getToggleSortingHandler() || noop;

  return (
    <TableCell $size={headerObj.getSize()} $isTitle>
      {isEmpty(headerContent) ? null : (
        <StyledWrapper>
          <span>{headerContent}</span>

          {canSortColumn ? (
            <StyledIconButton onClick={handleSort} $isSorted={isSorted}>
              <StyledSortIcon $isSorted={isSorted} />
            </StyledIconButton>
          ) : null}
        </StyledWrapper>
      )}
    </TableCell>
  );
};
